
















































import Vue from 'vue';
export default Vue.extend({
  name: 'frip-badge',
  props: {
    size: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
  },
});
